export function DownloadCSV(csvData: string, fileName: string) {
    const url = URL.createObjectURL(new Blob([csvData], { type: 'text/csv' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.csv`;
    link.click();
    URL.revokeObjectURL(url);
}